import CustomBreadcrumbs from '../../components/common/CustomBreadcrumbs';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import RefiDocsOutputRightSide from '../../components/refiDocsOutput/RefiDocsOutputRightSide';
import {
  selectDownloadLoadingState,
  selectDocType,
  selectTransactionId,
  selectDocsFormData,
  selectDocsResponse,
  selectRefiDocsFormData
} from '../../redux-state/selectors';
import RefiDocOutputLeft from '../../components/refiDocsOutput/RefiDocOutputLeft';
import DownloadIcon from '@mui/icons-material/Download';
import DocsOutputLeftSide from '../../components/docsOutput/DocsOutputLeftSide';
import DocsOutputRightSide from '../../components/docsOutput/DocsOutputRightSide';
import SecondaryButton from '../../components/common/button/SecondaryButton';
import PrimaryButton from '../../components/common/button/PrimaryButton';
import { generateDocsReport } from '../../components/utility/generateDocsReport';
import { DOWNLOAD_ALL } from '../../redux-state/types';
import html2pdf from 'html2pdf.js/dist/html2pdf.min.js';

function DocsOutput() {
  const loadingState = useSelector(selectDownloadLoadingState);
  const navigate = useNavigate();
  const docType =  useSelector(selectDocType);
  const transactionID =  useSelector(selectTransactionId);
  const simpleDocsFormData = useSelector(selectDocsFormData);
  const docsOutput = useSelector(selectDocsResponse);
  const refiDocsFormData = useSelector(selectRefiDocsFormData);

  let docsFormData = docType === "Refi-Docs"? refiDocsFormData: simpleDocsFormData
  const dispatch = useDispatch();

  const convertToPdf = async () => {
    if (!docsOutput || Object.keys(docsOutput).length === 0) {
      return;
    }

    const content = generateDocsReport(docsFormData, docsOutput);

    const options = {
      filename: (docsOutput["TransactionID"] ? `${docsOutput["TransactionID"]}.pdf` : 'docsOutput.pdf'),
      jsPDF: {
        unit: 'in',
        format: [10, 35],
        orientation: 'portrait',
      },
      html2canvas: {
        scale: 3,
      },
    };
    

    // Convert generated HTML report to PDF
    const blob = await html2pdf().set(options).from(content).outputPdf('blob');
    const pdfBlob = new File([blob], "myfile.pdf", { type: "application/pdf" });

    dispatch({
      type: DOWNLOAD_ALL,
      payload: pdfBlob,
    });

    // Gather the required JSON metadata
    const vin = simpleDocsFormData.vinCode || 'UNKNOWN_VIN'; 
    const fileName = options.filename;
    let callType = ""
    if (fileName.includes("REFD")){
      callType = "Refi-Docs"
    }else{
      callType = "Docs"
    }
    


    //Create FormData object
    const formData = new FormData();
    
    // Append the PDF Blob as a file
    formData.append('file', pdfBlob, fileName); 
    
    // Append the required JSON metadata
    formData.append('fileName', fileName);
    formData.append('call_type', callType);
    formData.append('vin', vin);

    // Send the FormData to the backend send_to_S3 endpoint
    try {
      const SERVER_URL = process.env.REACT_APP_API_URL;
      const backendUrl = `${SERVER_URL}/api/send_to_S3`; 
      const CSRFURL = `${SERVER_URL}/api/get-csrf-token`
      
      const response = await fetch(CSRFURL, {
        method: 'GET',
        credentials: 'include',
      })

      const response_data = await response.json();

      const CSRF_token_value = response_data.csrf_token; 

      if (!CSRF_token_value) {
          console.error("CSRF token not found.");
          return; // Exit or handle error
      }

      const result = await fetch(backendUrl, {
        method: 'POST',
        headers: {
          "X-Csrftoken": CSRF_token_value},
        body: formData,
        credentials: 'include'
      });
      
      const data = await result.json(); 
      console.log("S3 Upload Success:", data);
      
    } catch (error) {
      console.error("S3 Upload Failed:", error);
    }
  };

  return (
    <div className='p-4 lg:p-8 min-h-[900px]'>
      <div className='flex flex-row justify-between'>
        <div className='mb-4'>
          <CustomBreadcrumbs title={"Documents Output"} subtitle={"Docs Output"}/>
        </div>
        <div>
          <SecondaryButton
            text="Back"
            onClick={() => navigate(-1)}
          />
        </div>
      </div>

      <div className='text-3xl font-bold text-gray-900 mb-2'> {docType === "Refi-Docs"? "Refi-Docs": "Documents"} </div>
      <div className='text-gray-600 mb-6'>{transactionID}</div>
      <div className="w-full relative mb-8">
        <div className="absolute right-0">
          <PrimaryButton
            text={
              <>
                <DownloadIcon sx={{ mr: '6px' }} />
                Download
                {loadingState && (
                  <span className="ml-4 animate-spin inline-block w-4 h-4 border-2 border-t-transparent border-white rounded-full mr-2" />
                )}
              </>
            }
            className={`custom-download-button`}
            disabled={loadingState}
            onClick={convertToPdf}
          />
        </div>
      </div>

      <div className='flex flex-row w-full gap-3 lg:gap-6'>
        <div className='w-1/2'>
         {docType==="Refi-Docs"? < RefiDocOutputLeft /> :  <DocsOutputLeftSide />}
        </div>

        <div className="w-px bg-gray-300" />

        <div className='w-1/2'>
          {docType==="Refi-Docs"? <RefiDocsOutputRightSide /> :  <DocsOutputRightSide />}
        </div>
      </div>
    </div>
  );
}

export default DocsOutput;
